import { useModalContext } from "./ModalContext"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { X } from "lucide-react"
import { useSidebarSafe } from "../hooksLib/useSidebarSafe"

const SIDEBAR_WIDTH = "16rem" // 256px
const SIDEBAR_WIDTH_ICON = "3rem" // 48px
const SIDEBAR_WIDTH_MOBILE = "18rem" // 288px
const HEADER_HEIGHT = "3rem" // 48px mobile
const HEADER_HEIGHT_DESKTOP = "4rem" // 64px desktop

export function Modal({ showPreClose, setShowPreClose, children }) {
	const { setModalContent, modalOptions } = useModalContext()
	const { pathname } = useLocation()
	const sidebar = useSidebarSafe()

	// Calculate sidebar width based on state
	const getSidebarWidth = () => {
		if (!sidebar) return "0px"
		if (sidebar.isMobile) return sidebar.openMobile ? SIDEBAR_WIDTH_MOBILE : "0px"
		return sidebar.state === "expanded" ? SIDEBAR_WIDTH : SIDEBAR_WIDTH_ICON
	}

	const sidebarWidth = getSidebarWidth()
	// Use desktop header height (4rem) for medium+ screens, mobile (3rem) otherwise
	const headerHeight = sidebar ? (window.innerWidth >= 768 ? HEADER_HEIGHT_DESKTOP : HEADER_HEIGHT) : "0px"

	useEffect(() => {
		// navigation triggered remove modal
		setModalContent(null)
	}, [pathname, setModalContent])

	if (children == null) return null

	const onClickOut = (e) => {
		if (showPreClose) {
			return
		} // prevent closing without interacting with warning
		if (modalOptions?.PreCloseScreen != null) {
			console.log("showing preclose")
			setShowPreClose(true)
		} else {
			setModalContent(null)
		}
	}

	return (
		<div
			onClick={(e) => {
				if (modalOptions?.clickOutAnywhere) {
					onClickOut(e)
				}
			}}
			style={{
				left: sidebarWidth,
				top: headerHeight,
				right: "0px",
				bottom: "0px",
			}}
			className="scroll-lock fixed z-1000 overflow-hidden bg-black/50 backdrop-blur-[3px] min-w-[300px] min-h-[800px] *:pointer-events-none [&_button]:pointer-events-auto [&_.clickable]:pointer-events-auto">
			{!showPreClose && (
				<button
					onClick={onClickOut}
					className="absolute top-0 right-0 h-10 w-10 m-2 bg-white hover:bg-gray-200 cursor-pointer rounded-full transition-colors flex items-center justify-center clickable shadow-md"
					aria-label="Close">
					<X className="h-6 w-6 text-gray-800" />
				</button>
			)}
			{children}
			{showPreClose && modalOptions?.PreCloseScreen != null ? (
				<modalOptions.PreCloseScreen
					stay={(e) => {
						e.stopPropagation()
						setShowPreClose(false)
					}}
					leave={(e) => {
						e.stopPropagation()
						setShowPreClose(false)
						setModalContent(null)
					}}
				/>
			) : null}
		</div>
	)
}
